import { TiposArmazem, TiposEstoque, enumTipoEstoque } from './../../../classes/LocalEstoque';
import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { LocalEstoque } from 'src/app/classes/LocalEstoque';
import { LocalEstoqueService } from 'src/app/services/local-estoque.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import Swal from 'sweetalert2';
import { Fazenda } from 'src/app/classes/Fazenda';
import { FazendaService } from 'src/app/services/fazenda.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { enumErpIntegrado } from 'src/app/classes/Empresa';
import { UtilsService } from 'src/app/utils/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { LocalEstoqueFormsComponent } from './local-estoque-forms/local-estoque-forms.component';
import { ColumnModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Location } from '@angular/common';
import { finalize } from 'rxjs/operators';
import { Local } from 'src/app/classes/Local';
import moment from 'moment';

@Component({
  selector: 'app-local-estoque',
  templateUrl: './local-estoque.component.html',
  styleUrls: ['./local-estoque.component.scss']
})
export class LocalEstoqueComponent implements OnInit, AfterViewInit {

  @ViewChild('gridLocalEstoque', { static: false })
  gridLocalEstoque: SyncGridComponent;

  @ViewChild("LocalEstoqueForms", { static: false })
  LocalEstoqueForms: LocalEstoqueFormsComponent;
  @Input() IsNovo: boolean = false;

  locaisEstoques: LocalEstoque[];
  auxLocalEstoques: LocalEstoque[];
  localEstoque: LocalEstoque;
  id: number = 0;
  inserindo: boolean = false;
  carregando: boolean = false;
  isSuper: boolean = false;
  perfilLogado: number = 0;
  public isSubmit: boolean;
  textoBusca: string = "";
  localEstoqueColumns: ColumnModel[] = [];
  gridPageSettings: PageSettingsModel = {
    pageSizes: [10, 20, 50],
    pageSize: 20, // padrão alterado para 20
    pageCount: 4
  };
  gridHeight: string = '79vh';
  desabilitarAcoes: boolean = false;
  removendo: boolean = false;
  inativando: boolean = false;
  duplicando: boolean = false;

  integraERP: boolean = false;
  integraTotvs: boolean = false;

  // translate
  LOCAL_DE_ESTOQUE_ALTERADO: string = 'Local de Estoque alterado!';
  LOCAL_DE_ESTOQUE_CADASTRADO: string = 'Local de Estoque cadastrado!';
  DELETAR: string = 'Deletar';
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
  SIM: string = 'Sim';
  CANCELAR: string = 'Cancelar';
  FEITO: string = 'Feito!';
  LOCAL_DE_ESTOQUE_DELETADO: string = 'Local de Estoque deletado!';
  ERRO: string = "Erro!";
  CONFIRMAR_DELETE: string = "Se deletar, esta ação não poderá ser desfeita!";

  constructor(private localEstoquesService: LocalEstoqueService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private utils: UtilsService,
    private translate: TranslateService,
    private location: Location) {
    if (this.router.url.search("inserir") > 0) {
      if (!this.utils.verificarPermissaoUsuario('IncluirLocalEstoque')) {
        this.location.back();
      }
    }
    this.route.params.subscribe(res => {
      this.id = res.id;
      if (this.id > 0)
        if (!this.utils.verificarPermissaoUsuario('EditarLocalEstoque')) {
          this.location.back();
        }
    });

    this.route.params.subscribe(res => {
      this.id = res.id;
    });
  }

  ngOnInit() {
    var usuarioLogado = this.storageService.getUsuario();
    this.isSuper = usuarioLogado.isSuper;
    this.perfilLogado = usuarioLogado.Perfil;
    this.localEstoque = new LocalEstoque();
    this.listar();
    this.prepararGrid();
    let empresa = this.storageService.getEmpresa();
    if (empresa != null) {
      this.integraERP = empresa.ErpIntegrado > enumErpIntegrado.Nenhum;
      this.integraTotvs = empresa.ErpIntegrado == enumErpIntegrado.Totvs_RM;
    }

    this.perfilLogado = this.storageService.getUsuario().Perfil;
    this.inserindo = this.router.url.search("inserir") > 0;
    if (this.IsNovo) {
      this.inserindo = true;
    }
    this.localEstoque = new LocalEstoque();
  }

  configureTraducao() {
    this.LOCAL_DE_ESTOQUE_ALTERADO = this.translate.instant('LOCAL_DE_ESTOQUE_ALTERADO');
    this.LOCAL_DE_ESTOQUE_CADASTRADO = this.translate.instant('LOCAL_DE_ESTOQUE_CADASTRADO');
    this.DELETAR = this.translate.instant('DELETAR');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.SIM = this.translate.instant('SIM');
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.FEITO = this.translate.instant('FEITO');
    this.LOCAL_DE_ESTOQUE_DELETADO = this.translate.instant('LOCAL_DE_ESTOQUE_DELETADO');
    this.CONFIRMAR_DELETE = this.translate.instant('CONFIRMAR_DELETE');

  }
  prepararGrid(): void {
    this.localEstoqueColumns = [
      { type: "checkbox", width: 50 },
      {
        field: "Descricao",
        headerText: "Descrição",
        allowSorting: true,
        width: "100%"
      },
      {
        field: "DescricaoFazenda",
        headerText: "Fazenda",
        allowSorting: true,
        width: "100%"
      },
      {
        field: "GetTipoEstoque",
        headerText: "Tipo de Estoque",
        allowSorting: true,
        width: "100%"
      },
      {
        field: "dataAlteracaoStr",
        type: "string",
        headerText: "Ult. Mod.",
        allowSorting: true,
        sortComparer: (a: string, b: string) => {
          return moment(a, 'DD/MM/YYYY HH:mm').diff(moment(b, 'DD/MM/YYYY HH:mm'));
        }
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "AtivoDesc",
        headerText: "Status",
        type: "boolean",
        allowSorting: true,
        disableHtmlEncode: false,
        filter: {
          type: 'Menu'
        },
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatus(_data.Ativo);
        }
      }
    ];
  }

  doubleClick(event): void {
    this.editar(event)
  }

  badgeStatus(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.ajustarTamanhoGrid(), 100);
  }

  ajustarTamanhoGrid(): void {
    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement;
      const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement;
      const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement;
      const title = document.querySelector('app-local-estoque h5.titulo') as HTMLElement;
      const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement;

      if (!navbar || !toolbar || !title) {
        return;
      }

      const groupdropareaHeight = groupdroparea ? groupdroparea.offsetHeight : 0;
      const pagerHeight = pager ? pager.offsetHeight : 0;

      const altura = window.innerHeight - navbar.offsetHeight - groupdropareaHeight - toolbar.offsetHeight - title.offsetHeight - pagerHeight - 70;
      this.gridHeight = `${altura}px`;
    }, 100);
  }
  selecionar() {
    this.ERRO = this.translate.instant("ERRO");

    this.carregando = true;
    this.localEstoquesService.getLocalEstoque(this.id).subscribe(res => {
      this.localEstoque = new LocalEstoque();
      this.localEstoque = res;
      this.change();
      this.carregando = false;
    },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      })
  }

  listar() {
    this.ERRO = this.translate.instant("ERRO");
    this.carregando = true;
    this.localEstoquesService.getTodosGrupoEquipamentos()
      .pipe(
        finalize(() => {
          this.carregando = false;
        })
      )
      .subscribe(
        (res: LocalEstoque[]) => {

          this.locaisEstoques = res.map(u => Object.assign(new LocalEstoque(), u));;
          if (!this.inserindo)
            this.auxLocalEstoques = res;
          if (this.textoBusca != '')
            this.filtrar();
        },
        err => {
          this.utils.getErro(err);
        })
  }

  novo(): void {
    if (!this.utils.verificarPermissaoUsuario('IncluirLocalEstoque'))
      return;
    this.LocalEstoqueForms.abrirModal();
  }

  editar(entidade: LocalEstoque): void {
    let grupo;
    if (!entidade) {
      var grupos = this.gridLocalEstoque.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return;

      grupo = { ...grupos[0] };
    }
    else
      grupo = { ...entidade }
    this.LocalEstoqueForms.abrirModal(grupo);
  }

  ValidarSelectApenasUm(): boolean {
    var variedades = this.gridLocalEstoque.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (variedades.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var variedades = this.gridLocalEstoque.getSelectedRecords();
    if (variedades.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  confirmaDuplicar(): void {
    var variedades = this.gridLocalEstoque.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os locais de estoques selecionados serão duplicadas!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar locais de estoques",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(variedades);
      }
    });
  }

  duplicar(locais: LocalEstoque[]): void {
    this.duplicando = true
    this.localEstoquesService.duplicar(locais.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess("Locais de estoques duplicados com sucesso")
        this.listar();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }


  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais) return
    var lista = this.gridLocalEstoque.getSelectedRecords();
    if (lista.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }

    const todasInativas = lista.every(v => v.Ativo === false);
    const algumaInativa = lista.some(v => v.Ativo === false);

    if (todasInativas) {
      this.utils.handleWarning("Todos os locais de estoques selecionados já estão inativos");
      return;
    }

    let texto = "Os locais de estoques selecionados serão inativados!";
    if (algumaInativa) {
      texto += '<br> Alguns locais de estoques já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar locais de estoques",
    }).then((response) => {
      if (!response.dismiss) {
        const ativas = lista.filter(v => v.Ativo === true);
        this.inativar(lista);
      }
    });

  }

  inativar(lista: LocalEstoque[]): void {
    this.inativando = true
    this.localEstoquesService.inativar(lista.map(p => p.Id))
      .subscribe((res) => {
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const item = lista.find(v => v.Id.toString() === id);
            const nomeItem = item ? item.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeItem}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao Inativar Local de Estoque',
            html: `Os seguintes locais de estqoues não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } if (lista.filter(v => v.Ativo === false).length > 0) {
          const erros: string[] = [];
          lista.filter(v => v.Ativo === false).forEach(item => {
            const nomeItem = item ? item.Descricao : `ID ${item.Id}`;
            erros.push(`<b>${nomeItem}</b>: Já está inativo.`);
          });
          Swal.fire({
            title: 'Erro ao Inativar Local de Estoque',
            html: `os seguintes locais de estoques não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        }
        else {
          this.utils.handleSuccess("locais de estoque inativados com sucesso");
        }
        this.listar();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }

  finalizarSave(): void {
    this.listar();
  }

  confirmRemover() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirLocalEstoque'))
      return;

    this.ERRO = this.translate.instant("ERRO");
    this.FEITO = this.translate.instant("FEITO");
    this.CONFIRMAR_DELETE = this.translate.instant("CONFIRMAR_DELETE");
    this.CANCELAR = this.translate.instant("CANCELAR");
    this.SIM = this.translate.instant("SIM");
    this.LOCAL_DE_ESTOQUE_DELETADO = this.translate.instant("LOCAL_DE_ESTOQUE_DELETADO");

    var lista = this.gridLocalEstoque.getSelectedRecords();
    if (lista.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os locais de estoques selecionados serão excluidos, esta ação não poderá ser desfeita!",
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.remover(lista)
    });
  }

  remover(lista: LocalEstoque[]) {
    this.removendo = true;
    this.localEstoquesService.deleteLista(lista.map(p => p.Id)).subscribe(
      res => {
        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais variedades falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const variedade = lista.find(v => v.Id.toString() === id);
            const nomeVariedade = variedade ? variedade.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeVariedade}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir locais de estoques',
            html: `Os seguintes locais de estoques não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          this.utils.handleSuccess("Locais de estoques excluídos com sucesso");
        }

        this.listar();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });

  }

  filtrar() {
    this.locaisEstoques = this.auxLocalEstoques.filter(x =>
      x.Descricao.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
    );
  }

  cancelar() {
    this.router.navigate(['/estoques/local-estoque']);
  }

  get(id: number): LocalEstoque {
    if (!this.locaisEstoques || this.locaisEstoques.length === 0)
      return null;

    let grupo = this.locaisEstoques.filter(x =>
      x.Id == id
    );

    return grupo.length > 0 ? grupo[0] : new LocalEstoque();
  }

  change(abrindoModal: boolean = false) {
    if (abrindoModal)
      return;
  }
}
